import styled from 'styled-components';

export const Drop = styled.div`
  width: 300px;
  height: 300px;
  border-radius: 10px;
  margin: 22px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: 0;

  && img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  p {
    cursor: pointer;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    border: 1px dashed #fff;
    padding: 52px 0 32px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    color: #fff;
  }
`;

export const FileError = styled.span`
  color: #ee5253 !important;
`;
